import {SYNC_ALL_REQUEST, SYNC_REQUEST, OUTCOMES_REQUEST} from './requestsQueue';
import {stateBackup} from './local';

export function makeSyncAllRequest({campaignId, userId, state}) {
  let tests = [];
  Object.keys(state).forEach(key => {
    const testId = parseInt(key, 10);
    if (!Number.isNaN(testId)) {
      const testData = state[key];
      if (
        testData &&
        (testData.version === 0 || testData.version) &&
        (testData.status || testData.data)
      ) {
        tests.push({testId, version: testData.version});
      }
    }
  });

  return {
    campaignId,
    testId: true,
    userId,
    type: SYNC_ALL_REQUEST,
    status: true,
    data: {tests},
  };
}

export function makeSyncRequests({campaignId, userId, state, needPushing}) {
  let tests = [];
  Object.keys(state[campaignId]).forEach(key => {
    const testId = parseInt(key, 10);
    if (!Number.isNaN(testId) && needPushing.indexOf(testId) > -1) {
      const testData = state[campaignId][key];
      tests.push({testId, ...testData});
    }
  });

  return tests.map(test => {
    return {
      campaignId,
      testId: test.testId,
      userId,
      type: SYNC_REQUEST,
      version: test.version,
      status: test.status,
      data: test.data,
    };
  });
}

function clearTestBackup({testId, userId}) {
  const localUserBackup = stateBackup.get(userId);
  if (!localUserBackup) {
    return;
  }

  const localTestBackup = localUserBackup[testId];
  if (!localTestBackup) {
    return;
  }

  delete localUserBackup[testId];

  stateBackup.set(userId, localUserBackup);
}

export function makeOutcomesRequests({campaignId, userId, state}) {
  let tests = [];
  Object.keys(state).forEach(key => {
    const testId = parseInt(key, 10);
    if (!Number.isNaN(testId)) {
      const testData = state[key];
      if (
        testData &&
        testData.outcomes &&
        Array.isArray(testData.outcomes) &&
        testData.outcomes.length > 0
      ) {
        tests.push({testId, outcomes: testData.outcomes});
      }
    }
  });

  return tests.map(test => {
    return {
      campaignId,
      testId: test.testId,
      userId,
      type: OUTCOMES_REQUEST,
      version: 0,
      data: test.outcomes,
      callback: () => clearTestBackup({testId: test.testId, userId}),
    };
  });
}
